import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const pad = (n) => String(n).padStart(2, "0");

export const SaleCountdownBar = () => {
  const [cfg, setCfg] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      if (data.sale_countdown_enabled && data.sale_countdown_end) {
        const end = new Date(data.sale_countdown_end).getTime();
        if (!Number.isNaN(end)) {
          setCfg({ label: (data.sale_countdown_label || "Sale ends in").trim(), end });
          setNow(Date.now());
        }
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!cfg) return null;
  const diff = cfg.end - now;
  if (diff <= 0) return null;

  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);

  return (
    <div className="bg-charcoal text-white text-[11px] sm:text-xs" data-testid="sale-countdown-bar">
      <div className="max-w-[1800px] mx-auto px-4 h-8 flex items-center justify-center gap-2.5 text-center overflow-hidden">
        <span className="uppercase tracking-[0.16em] font-semibold text-magenta truncate">{cfg.label}</span>
        <span className="flex items-center gap-1 font-semibold tabular-nums tracking-wider" data-testid="sale-countdown-timer">
          {d}<span className="text-white/40 px-0.5">:</span>
          {pad(h)}<span className="text-white/40 px-0.5">:</span>
          {pad(m)}<span className="text-white/40 px-0.5">:</span>
          {pad(s)}
        </span>
      </div>
    </div>
  );
};
